import React from 'react';
import classnames from 'classnames';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { useParams } from 'react-router-dom';

import { LoaderColumn } from 'components';
import { ProfileCollaborators } from './../components';
import { useFeatureFlagState } from 'context';

import styles from './ProfileSidebar.module.scss';

interface ProfileSidebarProps {
  className?: string;
}

const getProfileCollaboratorsQuery = gql`
  query getProfileCollaborators($userId: String!) {
    profileByIdentifier(identifier: $userId) {
      ... on Profile {
        topContacts(first: 9) {
          contacts {
            id
            email
            name
            avatarUrl
          }
        }
        groups {
          id
          name
        }
      }
    }
  }
`;

export const ProfileSidebar: React.FC<ProfileSidebarProps> = ({ className }) => {
  const { userId } = useParams();
  const { groupsFeatureFlag } = useFeatureFlagState();

  const { error, data } = useQuery(getProfileCollaboratorsQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { userId },
  });

  if (data === undefined) return <LoaderColumn />;

  if (error) return <LoaderColumn />;

  const {
    profileByIdentifier: { topContacts: { contacts = [] } = {}, groups },
  } = data;

  return (
    <div className={classnames(className, styles.container)}>
      {((groups?.length > 0 && groupsFeatureFlag) || contacts?.length > 0) && (
        <ProfileCollaborators />
      )}
    </div>
  );
};
